import TimerConfig from "./TimerConfig";
export default TimerConfig;
